import React, { useRef, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useToast } from '@chakra-ui/react'

import { Page, PageHeader, ButtonSave, ButtonCancel } from 'components'

import {
  useQuestionDetailQuery,
  useQuestionCreateMutation,
  useQuestionUpdateMutation
} from '../hooks'

import { QuestionEditForm } from '../components'

export const QuestionEditPage = ({ isCreate = false, ...props }) => {
  const ref = useRef()
  const toast = useToast()
  const navigate = useNavigate()
  const { questionId } = useParams()
  const [questionCreate] = useQuestionCreateMutation()
  const [questionUpdate] = useQuestionUpdateMutation()
  const question = useQuestionDetailQuery(questionId, { skip: isCreate })

  const handleBack = useCallback(() => navigate('..'), [navigate])
  const handleSave = useCallback(() => ref.current.submit(), [ref])
  const handleCancel = useCallback(() => navigate('..'), [navigate])

  const handleCreate = useCallback(
    async question => {
      const { data } = await questionCreate({ variables: { question } })
      if (data.questionCreate.errors.length) {
        console.error(data.questionUpdate.errors) // @TODO
        toast({
          status: 'error',
          title: 'Erro ao editar questão.',
          description: 'Ocorreu um erro ao editar questão'
        })
      } else {
        toast({
          status: 'success',
          title: 'Questão criada.',
          description: 'A questão foi criada com sucesso.'
        })
        navigate(`../${data.questionCreate.id}`)
      }
    },
    [toast, navigate, questionCreate]
  )

  const handleUpdate = useCallback(
    async question => {
      const { data } = await questionUpdate({ variables: { question, questionId } })
      if (data.questionUpdate.errors.length) {
        console.error(data.questionUpdate.errors) // @TODO
        toast({
          status: 'error',
          title: 'Erro ao editar questão.',
          description: 'Ocorreu um erro ao editar questão'
        })
      } else {
        toast({
          status: 'success',
          title: 'Questão editada.',
          description: 'A questão foi editada com sucesso.'
        })
        navigate(`..`)
      }
    },
    [toast, navigate, questionUpdate, questionId]
  )

  const defaultData = {
    recommendations: [
      {
        bellow: 'Sugerimos ler sobre o tema.',
        above: 'Sugerimos ler sobre o tema.'
      },
      {
        bellow: 'Sugerimos ler sobre o tema.',
        above: 'Excelente para a fase em que se encontra.'
      },
      {
        bellow: 'Recomendamos ler e planear.',
        above: 'Ótimo para a fase que se encontra.'
      },
      {
        bellow: 'Recomendamos planear e atuar.',
        above: 'Bom para a fase em que se encontra.'
      },
      {
        bellow: 'É essencial atuar.',
        above: 'Razoável para a fase em que se encontra.'
      },
      {
        bellow: 'Já deveria ter atuado sobre este aspeto.',
        above: 'Siga assim. Está no bom caminho.'
      }
    ]
  }

  return (
    <Page>
      <PageHeader
        onBack={handleBack}
        heading={isCreate ? 'Criar Questão' : `Editar Questão #${questionId}`}>
        <ButtonSave onClick={handleSave} />
        <ButtonCancel onClick={handleCancel} />
      </PageHeader>
      <QuestionEditForm
        ref={ref}
        data={isCreate ? defaultData : question.data}
        isLoading={question.loading}
        onSubmit={isCreate ? handleCreate : handleUpdate}
      />
    </Page>
  )
}

export default QuestionEditPage
